import { useDispatch, useSelector } from 'react-redux';
import { actionCreators } from '../reducers/templateEditor';
import { StateShape as ReduxStateShape } from '../reducers';
import EditorRootDocument from '../components/EditorRootDocument';

const TemplateView = ({
    zoomPercentage,
    pageOrientation,
    pageDimensions,
    documentWidth
}: {
    zoomPercentage: number;
    pageOrientation?: string;
    pageDimensions?: { width: number; height: number };
    documentWidth?: number;
}) => {
    const dispatch = useDispatch();

    const { selectedId } = useSelector((state: ReduxStateShape) => {
        return {
            selectedId: state.templateEditor.selectedId,
        };
    });

    const isRootSelected = selectedId === 'root';

    return (
        <div
            style={{
                marginLeft: '10px',
                marginTop: '10px',
                marginBottom: '10px',
                marginRight: '10px',
                position: 'relative',
            }}
        >
            <div
                id="template-view-root"
                className={`placeholder ${isRootSelected ? 'selected' : ''}`}
                style={{
                    transformOrigin: 'left top',
                    transform: zoomPercentage ? `scale(${zoomPercentage / 100})` : 'scale(1)',
                    // Use precise dimensions if available, otherwise fallback to orientation-based sizing
                    width: documentWidth ? `${documentWidth}px` : (pageDimensions ? `${pageDimensions.width}px` : (pageOrientation === 'landscape' ? '100%' : '816px')),
                    height: pageDimensions ? `${pageDimensions.height}px` : (pageOrientation === 'landscape' ? 'auto' : '1056px'),
                    maxWidth: documentWidth ? 'none' : (pageOrientation === 'landscape' ? '2300px' : '1900px'),
                    aspectRatio: !pageDimensions && pageOrientation ? (pageOrientation === 'landscape' ? '1.414 / 1' : '1 / 1.414') : undefined,
                    margin: '0 auto',
                    transition: 'all 0.3s ease-in-out',
                    border: '1px solid #ddd',
                    backgroundColor: 'white',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    overflow: 'visible',
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    isRootSelected
                        ? dispatch(actionCreators.deselectElement())
                        : dispatch(actionCreators.selectElement('root'));
                }}
            >
                <p>Last modified: {new Date().toISOString()}</p>
                <EditorRootDocument />
            </div>
        </div>
    );
};

export default TemplateView;
